export const apiUrl = process.env.API_URL || 'https://eva.noretest.com';
export const tokenKey = '__auth-token__';

export const font = "'Open Sans', sans-serif";
export const defaultColor = '#182F74';
export const defaultSecondaryColor = '#C01000';
